import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'

import pages from '@/router/pages'
import parent from '@/router/parent'

Vue.use(VueRouter)

const userData = getUserData()

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior () {
		return { x: 0, y: 0 }
	},
	routes:	[
		{ path: '/', redirect: getHomeRouteForLoggedInUser(userData?.role) },
		...pages,
		...parent,
		{
			path: '*',
			redirect: 'error-404',
		},
	],
})

router.beforeEach((to, _, next) => {
	const isLoggedIn = isUserLoggedIn()

	// Redirect if not logged in but required auth
	if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
		return next({ name: 'auth-login' })
	}

	if (isLoggedIn) {
		const mustResetPassword = !!getUserData()?.require_reset_password
		const isResetPage = to.name === 'required-reset-password'

		// 1. If Reset required — go to reset-page
		if (mustResetPassword && !isResetPage) {
			return next({ name: 'required-reset-password' })
		}

		// 2. If Reset Not required — avoid reset-page
		if (!mustResetPassword && isResetPage) {
			return next({ name: 'error-404' })
		}
	}

	//Check permissions
	if (!canNavigate(to)) {
		return next(isLoggedIn ? { name: 'home' } : { name: 'auth-login' })
	}

	// Redirect if logged in
	if (to.meta.redirectIfLoggedIn && isLoggedIn) {
		return next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
	}
	return next()
})

export default router
